<template>
  <div class="cart-product-line">
    <div class="cart-product-line-cell">
      <div class="mod-cell">
        <span>{{line_data.OMOD}} - {{line_data.OLIB_MOD}}</span>
        <span><small>{{$_('color')}}: <strong>{{line_data.OCOL}}</strong></small></span>
      </div>
    </div>
    <div class="cart-product-line-cell">
      <span>{{line_data.OTAIL1}}{{line_data.OTAIL2}}</span>
    </div>
    <div class="cart-product-line-cell">
      <span>{{line_data.OLIB_OPT}}</span>
    </div>
    <div class="cart-product-line-cell">
      <NumberField ref="product_quantity"
        @update-value="getStockInfo($event)" 
        :val="line_data.OQTE"
        :immediate="false" />
    </div>
    <div class="cart-product-line-cell product-avaibility" :class="{ 
        'in-stock': this.pokstk === 1,   
        'out-of-stock': this.pokstk === 2,   
        'contact-us': this.pokstk === 3}">
          <span class="stock-mark"></span>
           <span class="libelle-stock" :class="{stock: pokstk === 1, reappro: pokstk === 2, contact: pokstk === 3, error: pokstk === -1}">{{stock_info}}</span>
    </div>
    <div class="cart-product-line-cell amount">
      <span>{{line_data.OMTHT}} {{pcdev}} HT</span>
      <span>{{line_data.OMTTTC}} {{pcdev}} TTC</span>
    </div>
    <div class="cart-product-line-cell">
      <span @click="vDeleteProduct()" class="trash-line"><img src="@/modules/produit/assets/img/trash.png"/></span>
    </div>
  </div>
</template>

<script>

import NumberField from '@/common/components/widget/NumberField/NumberField'

import cartService from "@/modules/panier/services/cartService";
import productService from "@/modules/produit/services/productService";

export default {
  props: ["line_data", "index"],
  name: "CartProductLine",
  components: {
    NumberField,
  },
  data() {
    return {
      pcdev: this.$store.getters['panier/get_pcdev'],
      pokstk: 0,
      pstk: 0,
      punit_stk: '',
      quantity: 1, 
      restocking: Object,
      stock_info: '',
      display_add_to_cart: true
    }
  },
  created() {
    console.error(this.line_data);
   this.getStockInfo(this.$props.line_data.OQTE);
  },
  methods: {
    setQuantity(val) {
      cartService.addToCart({
        p_mod: this.$props.line_data.OMOD,
        p_opt: this.$props.line_data.OOPT,
        p_tail1: this.$props.line_data.OTAIL1,
        p_tail2: this.$props.line_data.OTAIL2,
        p_col: this.$props.line_data.OCOL,
        p_marq: this.$props.line_data.OMARQ,
        p_qte: val - this.$props.line_data.OQTE,
        pcpromo: '',
        p_sup: 0
      })
      .then(res => {
        if(res.data !== undefined) {  
          this.$store.dispatch('panier/SET', {key: 'reload_cart', value: true});
        }
      })
    },
    getStockInfo(nQuantity) {

      productService.getStockInfo({
        pmod: this.$props.line_data.OMOD,
        ptail1: this.$props.line_data.OTAIL1,
        ptail2: this.$props.line_data.OTAIL2,
        popt: this.$props.line_data.OOPT,
        pcol: this.$props.line_data.OCOL,
        pmarq: this.$props.line_data.OMARQ,
        pqte: nQuantity

      }).then(res => {
        
        if (res.data !== undefined) {

          if(res.data.PFDS === 1 && (nQuantity > res.data.PPOT)) {
            this.display_add_to_cart = false;
          } else {
            this.display_add_to_cart = true;
          }


          this.pokstk = res.data.POKSTK;
          this.pstk = res.data.PSTK;
          this.punit_stk = res.data.PUNIT_STK;
          this.pfds = res.data.PFDS;

          if(res.data.PPOT !== undefined) {
            this.ppot = res.data.PPOT;
          }

          if (res.data.DS_O !== undefined) this.restocking = res.data.DS_O.OUT[0];

          if(this.$props.line_data.OTAIL1 === '' ||
            this.$props.line_data.OTAIL2 === '' ||
            this.$props.line_data.OOPT === '' ||
            this.$props.line_data.OCOL === '' ||
            this.$props.line_data.OMARQ === ''
          ) {
            this.pokstk = -1;
          }

          this.setDisplayStockInfo(nQuantity);
          this.setQuantity(nQuantity)
        }
      }).catch(err => {
        console.error(err);
      });
    },
    setDisplayStockInfo(nQuantity) {

      if(this.pfds === 1) {

        if(nQuantity > this.ppot) {
          this.stock_info = this.$_('potential_excedeed')+'('+parseInt(this.ppot)+' '+this.$_('pieces')+')';
        } else {
          this.pokstk = 1;
          this.stock_info = this.$_('in_stock');
        }

      } else {

        switch (this.pokstk) {
          case 1:
            this.stock_info = this.$_('in_stock');
            break;
          case 2:
            this.stock_info = this.$_('out_of_stock');
            break;
          case 3:
            this.stock_info = this.$_('out_of_stock_contact_us')+' ('+this.pstk+' '+this.$_('available')+')';
            break;
          default:
            this.stock_info = this.$_('complete_all_fields')
            break;
        }
      }

      if(this.pokstk === 2 || this.pokstk === 3) {
        if(this.restocking !== undefined) {
          this.stock_info += ' ('+this.pstk+this.punit_stk+' '+this.$_('in_stock_and')+' '+this.restocking.TSTKDISP+this.punit_stk+' '+this.$_('on_the')+' '+this.restocking.TDATEDISP+')';
        }
      } else {
        if(this.restocking !== undefined && this.restocking.TDATEDISP !== undefined) {
          this.stock_info += ' ('+this.pstk+this.punit_stk+' '+this.$_('in_stock').toLowerCase()+')';
        }
      } 
    },
    vDeleteProduct() {

      cartService.addToCart({
        p_mod: this.$props.line_data.OMOD,
        p_opt: this.$props.line_data.OOPT,
        p_tail1: this.$props.line_data.OTAIL1,
        p_tail2: this.$props.line_data.OTAIL2,
        p_col: this.$props.line_data.OCOL,
        p_marq: this.$props.line_data.OMARQ,
        p_qte: 0,
        pcpromo: '',
        p_sup: 1
      })
      .then(res => {
        if(res.data !== undefined) {  
          this.$store.dispatch('panier/SET', {key: 'reload_cart', value: true});
        }
      });
    }
  }
};
</script>

<style scoped>
.cart-product-line {
  display: flex;
  border: solid 1px #e9e9e9;
  margin-top: 10px;
  transition: all 0.3s;
  align-items: center;
}
.cart-product-line-cell {
  display: flex;
  width: calc(100% / 6);
  justify-content: center;
  padding: 25px 0px;
}
.cart-product-line-cell span {
  color: #585858;
  font-size: var(--fz-md);
  transition: all 0.3s;
}
.cart-product-line:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.cart-product-line:hover .cart-product-line-cell span {
  color: #8b8b8b;
}
/deep/
.number-field {
  margin: 0;
}
.mod-cell {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.trash-line {
  border: solid 1px #61424D;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trash-line:hover {
  cursor: pointer;
}
.trash-line img {
  width: 20px;
}
.amount {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.stock-mark {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 5px;
}
.out-of-stock span {
  color: orange;
}
.out-of-stock .stock-mark {
  background-color: orange;
}
.stock-line .stock-line-cell.in-stock span {
  color: #8BC133;
}
.in-stock .stock-mark {
  background-color: #8BC133;
}
.contact-us {
  color: red;
}
.contact-us .stock-mark {
  background-color: red;
}
.product-avaibility {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.product-avaibility .stock-mark {
  margin-bottom: 5px;
}
</style>